<template>
  <button class="bot-deci" :class="lineAfter?'line-after':''"></button>
</template>

<script>
export default {
  props: {
    lineAfter: {
      type: Boolean,
      required: false
    }
  }
}
</script>


<style lang="scss" scoped>
@import "../../sass/helpers/mixins";
@import "../../sass/helpers/variables";
.bot-deci {
  background-color: #f6d7d0;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin: 5px;
  position: relative;
  @include insetshadow( 0 3px 5px #555);
  &:before, &:after{
    content: "";
    position: absolute;
    top: 44%;    
    width: 40px;
    height: 4px;
    background-color: red;
    display: none;
  }
  &:before {
    display: block;
    left: -45px;
  }
  &.line-after{
    &:after {
      display: block;
      right: -45px;
    }
  }
  
}
</style>





// WEBPACK FOOTER //
// ActividadDeciBoton.vue?f958c84e